// extracted by mini-css-extract-plugin
export default {"codarx_link":"styles_codarx_link__jOvRu"};